import { Organization, User } from '@/types';
import api from './client/axios';
import { ApiResponse, CurrentLocationDetail } from '@packages/database/types';

export const getCurrentLocations = async (): Promise<
  CurrentLocationDetail[]
> => {
  const response =
    await api.get<ApiResponse<CurrentLocationDetail[]>>('/locations/current');
  return response.data.data!;
};
